import { api } from '@/services/api.config';

export async function fetchPrimaryClientAccountBalance(currency: string, bearer?: string): Promise<string | undefined> {
  // No Offset on purpose: the endpoint guarantees the primary account is
  // included in the first page when no Offset is passed, so one fetch is enough.
  const res = await api.fetchClientAccountList({ ClientType: '', Limit: 20 }, undefined, bearer);
  if (!res.Success) throw new Error(res.ErrorMessage);

  const primary = res.ClientAccounts.find((account) => account.IsPrimaryAccount === '1');
  const available = primary?.Balances?.find((balance) => balance.Currency === currency)?.AvailableBalance;

  return available === undefined ? undefined : String(available);
}

export async function resolveSpendableBalance({
  clientAccountsEnabled,
  currency,
  fallbackBalance,
  bearer,
}: {
  clientAccountsEnabled: boolean;
  currency: string;
  fallbackBalance: string;
  bearer?: string;
}): Promise<string> {
  if (!clientAccountsEnabled) return fallbackBalance;
  const primaryBalance = await fetchPrimaryClientAccountBalance(currency, bearer);

  return primaryBalance ?? '0.00';
}
